// @owners { team: patients }
import { SIZES } from '@alto/design-library-tokens';
import { SizedImage } from '@alto/design-system';
import React from 'react';
import { getImage } from '~shared/assets/images/getImage';
import { getCompanyName } from '~shared/config/getCompanyName';

export const GooglePlayImage = () => {
  return (
    <SizedImage
      source={getImage('androidAppDownload')}
      pixelSize={SIZES.ILLUSTRATION.XL.value}
      maxHeight={SIZES.ILLUSTRATION.SM.value}
      // The FuzeRx badges are a wider ratio than Alto's, so letterbox rather than fill the
      // box, which would crop the badge's rounded border.
      resizeMode="contain"
      accessibilityLabel={`Download ${getCompanyName()} Android app`}
    />
  );
};
